<template>
  <div class="filter-equipment-wrapper">
    <multi-picker
      :active="active"
      :children="equipment_edge_children"
      :title="$t('roomFinder.equipments')"
      :is-active="checkIsActive"
      :icon="'/static/img/location-light.svg'"
      :close-on-click="false"
      @click-child="handleSelect"
    />
    <div class="equipment-list" v-for="item in picked_label">
        {{ item.label }} <div @click="handleSelect(item)"> <img class="close-icon" src="/static/img/icon_close.svg" alt="Icon"> </div>
    </div>
  </div>

</template>

<script>
import MultiPicker from "../parts/multi-picker";
import {mapState} from "vuex";
export default {
  name: "search-filter-equipments",
  components: {MultiPicker},
  computed: {
    ...mapState ({
      equipment_edge_children: s => s.equipment.equipments.map((e) => ({
        id: e.id,
        label: e.text.name,
      })),
      picked: s => s.equipment.picked,
      active: s => s.equipment.equipments.length > 0 && !s.equipment.loading,
    }),
    picked_label() {
      return this.equipment_edge_children.filter(equipment => this.picked.includes(equipment.id));
    },
  },
  async mounted () {
    window.addEventListener('app:lang', this.fetchEquipments)
    await this.fetchEquipments(false);
  },
  beforeDestroy() {
    window.removeEventListener('app:lang', this.fetchEquipments)
  },
  methods: {
    async fetchEquipments (forced = true) {
      await this.$store.dispatch('equipment/fetch', forced);
    },
    checkIsActive (item) {
      return this.picked.indexOf(item.id) !== -1;
    },
    handleSelect (item) {
      this.$store.commit('equipment/TOGGLE_PICKED', item.id);
    }

  }
}
</script>

<style >


</style>



// WEBPACK FOOTER //
// src/pages/search/picker/search-filter-equipments.vue